import { styled } from '@/styled-system/jsx';

export const StyledRow = styled('div', {
  base: {
    clear: 'both',
    paddingTop: '{spacing.1x}',
    paddingBottom: '{spacing.1x}',
    paddingLeft: '0',
    paddingRight: '0',
  },
  variants: {
    size: {
      zero: {
        padding: '0',
      },
      sm: {
        clear: 'both',
        paddingTop: '{spacing.xs}',
        paddingBottom: '{spacing.xs}',
        paddingLeft: '0',
        paddingRight: '0',
      },
      md: {
        paddingTop: '{spacing.2x}',
        paddingBottom: '{spacing.2x}',
        paddingLeft: '0',
        paddingRight: '0',
      },
      lg: {
        paddingTop: '{spacing.3x}',
        paddingBottom: '{spacing.3x}',
        paddingLeft: '0',
        paddingRight: '0',
      },
      xl: {
        paddingTop: '{spacing.6x}',
        paddingBottom: '{spacing.6x}',
        paddingLeft: '0',
        paddingRight: '0',
      },
    },
    flex: {
      true: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
      },
    },
  },
});
